export default {
    title: "Portal Pesquisa",
    header: "@:views.survey.customer.title",
    model: {
        service_rating: {
            label: "Em uma escala de 1 a 10, onde 1 é muito insatisfeito e 10 muito satisfeito, como você avaliaria este serviço?",
        },
        service_likes: {
            label: "O que você gostou?",
            placeholder: ""
        },
        service_improvements: {
            label: "O que pode ser melhorado?",
            placeholder: ""
        },
        service_easy_to_follow: {
            label: "Em uma escala de 1 a 10, sendo 1 nada claro e 10 fácil de entender, como você classificaria as comunicações relacionadas a este site?"
        },
        item: {
            setup_rating: {
                label: "Em uma escala de 1 a 10, onde 1 é muito difícil e 10 é muito fácil, quão difícil foi instalar e configurar seu \"{name}\"?",
            },
            comments: {
                label: "Forneça comentários sobre {name}?",
                placeholder: ""
            }
        }
    },
    disclaimer: "Esteja ciente de que suas respostas à pesquisa serão compartilhadas com O-I e podemos entrar em contato com você em relação ao seu feedback.",
    button: {
        submit: {
            cta: "Enviar",
            processing: "Enviando"
        }
    }
}